import React, { useState, useRef } from 'react'
import BreadCrumb from '../../components/breadcrumb'
import { Grid, Row, Col } from 'react-flexbox-grid'

import { JobDetailStyle } from './index.style'
// import BrownBox from '../../static/images/brown-box.jpg'
import JobDetailImage from '../../static/images/job-detail.jpg'
import ReCAPTCHA from 'react-google-recaptcha'
import Helmet from 'react-helmet'

import Career from '../../services/career'
import swal from 'sweetalert'

import { dataJobDetail } from '../../translate/data-job-detail'
import dompurify from 'dompurify'

const JobDetail = () => {
  const urlLocation = window.location.pathname.split('/')[3]
  const data = dataJobDetail
  const jobData = data.find(o => o.url === urlLocation)
  const recaptchaRef = useRef(null)
  const inputFile = useRef(null)
  const [fullName, setFullName] = useState('')
  const [email, setFullEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [personalWeb, setPersonalWeb] = useState('')
  const [perusahaan, setPerusahaan] = useState('')
  const [dataUpload, setUpload] = useState('')
  const [e_name, setE_name] = useState(false)
  const [e_email, setE_email] = useState(false)
  const [e_phoneNumber, setE_phone] = useState(false)

  const handleChangeInput = async event => {
    setUpload(event.target.files[0])
  }

  const registerCareer = () => {
    if (recaptchaRef.current.getValue() == '') {
      swal('Failed', 'Please completed captcha', 'warning')
    } else {
      const regex_name = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g
      const regex_email = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      const regex_phone = /^[0-9\b]+$/

      if (fullName.match(regex_name)) {
        setE_name(false)
      } else if (fullName == '') {
        setE_name(<p className="error-handling">Nama tidak boleh kosong</p>)
      } else {
        setE_name(<p className="error-handling">Isikan nama dengan benar</p>)
      }

      if (email.match(regex_email)) {
        setE_email(false)
      } else if (email == '') {
        setE_email(<p className="error-handling">Email tidak boleh kosong</p>)
      } else {
        setE_email(<p className="error-handling">Isikan email dengan benar</p>)
      }

      if (phoneNumber.match(regex_phone)) {
        setE_phone(false)
      } else if (phoneNumber == '') {
        setE_phone(
          <p className="error-handling">Nomor telepon tidak boleh kosong</p>
        )
      } else {
        setE_phone(
          <p className="error-handling">Isikan nomor telepon dengan benar</p>
        )
      }

      if (personalWeb == '') {
        setPersonalWeb('Tidak ada')
      }
      if (perusahaan == '') {
        setPerusahaan('Tidak ada')
      }

      var dataForm = new FormData()
      dataForm.set('position', jobData.title)
      dataForm.append('name', fullName)
      dataForm.append('email', email)
      dataForm.append('phoneNumber', phoneNumber)
      dataForm.append('website', personalWeb)
      dataForm.append('company', perusahaan)
      dataForm.append('cv', dataUpload)
      dataForm.append('nameFile', dataUpload.name)
      dataForm.append('typeFile', dataUpload.type)
      dataForm.append('size', dataUpload.size)

      Career(dataForm)
        .then(() => {
          swal('Success', 'Your CV has been sent.', 'success')
          clearForm()
          recaptchaRef.current.reset()
        })
        .catch(() => {
          swal('Failed', 'Please cek your form, and try again', 'warning')
          recaptchaRef.current.reset()
        })
    }
  }

  const clearForm = () => {
    setFullName('')
    setFullEmail('')
    setPhoneNumber('')
    setPersonalWeb('')
    setPerusahaan('')

    setUpload('')
    setE_name(false)
    setE_email(false)
    setE_phone(false)
  }

  const onChange = value => {
    // eslint-disable-next-line no-const-assign
    recaptchaRef = value
  }

  const handleClickUpload = () => inputFile.current.click()

  const sanitizer = dompurify.sanitize

  return (
    <JobDetailStyle>
      <Helmet>
        <title>Detail Lowongan Pekerjaan {jobData.title} | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada"
        />
        <meta
          property="og:title"
          content="Info Lowongan Pekerjaan | halojasa.com"
        />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta
          property="og:description"
          content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada"
        />
        <meta
          property="og:url"
          content={'https://halojasa.com/about/job-detail/' + jobData.url}
        />
        <meta
          property="og:image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/karir-ls.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png"
        />
        <meta
          property="og:image:secure_url"
          itemProp="image"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/karis-sq.png"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="300" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta
          name="twitter:title"
          content="Info Lowongan Pekerjaan | halojasa.com"
        />
        <meta
          name="twitter:description"
          content="Ingin bergabung dan berkontribusi menciptakan kebermanfaatan bersama kami ? Cek lowongan kerja yang ada"
        />
        <meta
          name="twitter:image:src"
          content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
        />
        <meta
          name="p:domain_verify"
          content="4e6fcb4deba1a02d84225fad69babc0b"
        />
        <meta name="keyword" content="lowongan kerja halo jasa" />
      </Helmet>
      <div style={{ paddingTop: 100 }} className="main-job-list-wrapper">
        <Grid>
          <Row>
            <Col lg={12} sm={12} md={12} xs={12}>
              <BreadCrumb
                options={[
                  {
                    name: 'Beranda',
                    link: '/'
                  },
                  {
                    name: 'Tentang Kami',
                    link: '/bantuan/tentang-kami/'
                  },
                  {
                    name: 'Karir',
                    link: '/karir/all/'
                  },
                  {
                    name: 'Job List',
                    link: '/about/job-list/'
                  },
                  {
                    name: jobData.title,
                    link: false
                  }
                ]}
              ></BreadCrumb>
            </Col>
          </Row>

          <Row>
            <div className="left-job-detail">
              <div className="left-job-detail-top">
                <img src={JobDetailImage} alt="" />
                <div className="left-job-detail-top-text">
                  <p>Career Opportunity</p>
                  <h1>{jobData.title}</h1>
                </div>
              </div>

              <div className="left-job-detail-bottom">
                <p className="description-title">Description</p>
                <p
                  className="description-text"
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(jobData.description)
                  }}
                />

                <p className="description-title">Responsibilities</p>
                <p
                  className="description-text"
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(jobData.requirement)
                  }}
                />
              </div>
            </div>

            <div className="right-job-detail">
              <p>Apply for this job?</p>
              <label>Nama Lengkap</label>
              <input
                type="text"
                placeholder="eg. Ahmad Widodo"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
              />
              {e_name}

              <label>Email</label>
              <input
                type="text"
                placeholder="eg.  foo@bar.com"
                value={email}
                onChange={e => setFullEmail(e.target.value)}
              />
              {e_email}

              <label>No Handphone</label>
              <input
                type="text"
                placeholder="0812 3456 7890"
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />
              {e_phoneNumber}

              <label>Website Pribadi</label>
              <input
                type="text"
                placeholder="Tuliskan alamat website anda"
                value={personalWeb}
                onChange={e => setPersonalWeb(e.target.value)}
              />

              <label>Perusahaan Sekarang</label>
              <input
                type="text"
                placeholder="Tuliskan tempat anda bekerja sekarang"
                value={perusahaan}
                onChange={e => setPerusahaan(e.target.value)}
              />

              <div className="upload-wrapper">
                <p>Upload Curiculum Vitae (CV)</p>
                <p>
                  Upload CV atau Resume dalam format .doc atau .pdf dengan
                  maksimal ukuran file 2MB
                </p>

                <div className="upload-file-wrapper">
                  <img src={dataUpload} alt="" />
                  <div>
                    <p className="file-text">
                      {dataUpload.name || 'tidak ada file terpilih'}
                    </p>
                    <input
                      className="input-image"
                      name="file"
                      onChange={handleChangeInput}
                      ref={inputFile}
                      type="file"
                      src={false}
                    />
                    <button onClick={handleClickUpload}>Upload File</button>
                  </div>
                </div>

                <div className="captcha-wrapper">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LfFmb8UAAAAALlXXVTp6yV9iCuTuiGvtvVi8liX"
                    onChange={onChange}
                  />
                </div>
              </div>

              <button onClick={registerCareer} className="button-kirim">
                KIRIM
              </button>
            </div>
          </Row>
        </Grid>
      </div>
    </JobDetailStyle>
  )
}

export default JobDetail
